let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1iJco")).then(() => parcelRequire('7e8SU'));